export default {
    Generated: 0,
    Manufactured: 1,
}


// WEBPACK FOOTER //
// ./src/components/application/QRC/changeStatus.js